import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';

import I18n from '@js/modules/translations';

import {
    fetchBlog
} from '@js/actions';

import {
    getIsOwner
} from '@js/selectors';

import BlogForm from './display/form';
import BlogList from './display/list';


class BlogShow extends React.PureComponent {
    static propTypes = {
        // From connect
        userId: PropTypes.number,
        isOwner: PropTypes.bool,
        blog: PropTypes.object,
        blogArticles: PropTypes.array,
        fetchBlog: PropTypes.func
    };

    static defaultProps = {
        userId: 1,
        isOwner: false
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.fetchBlog(this.props.userId, {page: 1});
    }

    // _handlePaginationClick = (paginate) => {
    //     const params = {page: paginate.selected + 1};
    //
    //     this.props.fetchBlog(this.props.userId, params);
    // };

    render() {
        return (
            <div className="blog">
                <h1 className="blog-title">
                    {I18n.t('js.blog.index.title')}
                </h1>

                {
                    !!this.props.blog &&
                    <div className="row">
                        <div className="col s12">
                            {
                                !!(this.props.isOwner && this.props.blog.id) &&
                                <BlogForm currentUserId={this.props.userId}/>
                            }

                            <BlogList articles={this.props.blogArticles}/>
                        </div>
                    </div>
                }
            </div>
        );
    }
}


export default connect((state, props) => ({
    userId: props.userId || state.userState.currentId,
    isOwner: getIsOwner(state, state.blogState.blog && state.blogState.blog.userId),
    blog: state.blogState.blog,
    blogArticles: state.blogState.blogArticles
}), {
    fetchBlog
})(BlogShow);
